import React, { useState } from 'react';
import { SERVICIOS, METODOS_PAGO } from '../../data/constants';
import { waLink } from '../../utils/whatsapp';
import { gaEvent, adsLeadConversion } from '../../utils/analytics';
import type { Servicio } from '../../types';
import './Servicios.css';

const ServicioCard: React.FC<{ s: Servicio; onContratar: () => void }> = ({ s, onContratar }) => {
  const [verMas, setVerMas] = useState(false);
  const [verEjemplos, setVerEjemplos] = useState(false);

  const parrafos = s.desc.split('\n\n');

  return (
    <div className="servicio-card">
      <div className="servicio-num">{s.num}</div>
      <div className="servicio-titulo">{s.titulo}</div>
      <div className="servicio-desc">
        {parrafos.map((p, i) => (
          <p key={i} style={{ margin: i > 0 ? '0.7rem 0 0' : '0' }}>{p}</p>
        ))}
      </div>

      {s.idealPara && !s.idealParaToggle && (
        <div className="servicio-ideal">
          <div className="servicio-sublabel">Ideal para:</div>
          <ul className="servicio-list">
            {s.idealPara.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </div>
      )}

      {s.idealPara && s.idealParaToggle && (
        <div className="servicio-ejemplos-wrap">
          <button className="btn-ver-ejemplos" onClick={() => setVerMas(!verMas)}>
            {verMas ? 'Mostrar menos ↑' : 'Mostrar más ↓'}
          </button>
          {verMas && (
            <div className="servicio-ideal">
              <div className="servicio-sublabel">Ideal para:</div>
              <ul className="servicio-list">
                {s.idealPara.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
          )}
        </div>
      )}

      {s.ejemplos && (
        <div className="servicio-ejemplos-wrap">
          <button className="btn-ver-ejemplos" onClick={() => setVerEjemplos(!verEjemplos)}>
            {verEjemplos ? 'Ocultar ejemplos ↑' : 'Ver ejemplos ↓'}
          </button>
          {verEjemplos && (
            <ul className="servicio-list servicio-list--ejemplos">
              {s.ejemplos.map((ej, i) => <li key={i}>{ej}</li>)}
            </ul>
          )}
        </div>
      )}

      {s.duracion && (
        <div className="servicio-duracion">Duración: {s.duracion}</div>
      )}

      <div className="servicio-precio">{s.precio}</div>
      <div className="servicio-separator" />
      <button
        className="btn-primary"
        style={{ fontSize: '0.7rem', width: '100%', justifyContent: 'center' }}
        onClick={onContratar}
      >
        {s.btnLabel}
      </button>
    </div>
  );
};

const Servicios: React.FC = () => {
  /* Se abre con window.open, que no pasa por el listener de clics de
     analytics.ts: hay que registrar la conversión a mano o esta intención
     —la más comercial del sitio, alguien pidiendo contratar— no se mide. */
  const abrirPago = (nombre: string, monto: string) => {
    const msg = monto === '0'
      ? `Hola, quiero agendar el servicio "${nombre}". ¿Cómo procedo?`
      : `Hola, quiero contratar el servicio "${nombre}" ($${Number(monto).toLocaleString('es-CL')}). ¿Cómo procedo con el pago?`;
    gaEvent('whatsapp_click', { link_text: `Servicio: ${nombre}`, servicio: nombre, monto });
    adsLeadConversion('whatsapp');
    window.open(waLink(msg), '_blank');
  };

  return (
    <section id="servicios" style={{ background: 'var(--dark)' }}>
      <div className="section-label">Servicios Online</div>
      <h2 className="section-title">Servicios <em>en línea</em></h2>
      <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', lineHeight: 1.9, maxWidth: 560, marginTop: '0.4rem', marginBottom: '3rem' }}>
        Acceda a nuestros servicios jurídicos de forma rápida desde cualquier lugar.
      </p>

      <div className="servicios-grid">
        {SERVICIOS.map((s) => (
          <ServicioCard
            key={s.num}
            s={s}
            onContratar={() => abrirPago(s.titulo, s.precioNum)}
          />
        ))}
      </div>

      <div className="pagos-section">
        <div className="section-label">Métodos de pago disponibles</div>
        <div className="pagos-grid">
          {METODOS_PAGO.map((p, i) => (
            <div className={`pago-metodo ${p.activo ? 'available' : ''}`} key={i}>
              <div className="pago-logo">{p.logo}</div>
              <div className="pago-nombre">{p.nombre}</div>
              <div className="pago-desc">{p.desc}</div>
              {p.activo ? (
                <span className="pago-badge-activo">Disponible</span>
              ) : (
                <span className="pago-badge-pronto">Próximamente</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Servicios;
